export function isCanceledError(e) {
    return (e === null || e === void 0 ? void 0 : e.isCancelError) === true;
}
self.addEventListener('error', e => {
    return isCanceledError(e.error);
});
export default class CanceledError extends Error {
    constructor(message) {
        super(message !== null && message !== void 0 ? message : 'Canceled');
        this.isCancelError = true;
    }
}
